/* eslint-disable import/no-default-export */
import React from 'react';

import DueDateIconComplete from '../../icons/DuedateCompleteIcon';
import DueDateIcon from '../../icons/DuedateIcon';

import IconBadge from './IconBadge';

const TWENTY_FOUR_HOURS = 86400000;
const THIRTY_SIX_HOURS = 129600000;

const DueDateBadge = ({ children, dueDate, isComplete = false }) => {
  const now = new Date();
  const dueDateTime = dueDate.getTime();

  // tslint:disable:restrict-plus-operands
  const isDueSoon = dueDateTime - TWENTY_FOUR_HOURS <= now && dueDateTime > now;
  const isDueNow = dueDateTime <= now && dueDateTime + THIRTY_SIX_HOURS > now;
  const isPastDue = dueDateTime + THIRTY_SIX_HOURS <= now;
  // tslint:enable:restrict-plus-operands

  let bgColor = 'transparent';
  let fontColor = 'N400';
  let icon = <DueDateIcon />;

  if (!isComplete && isPastDue) {
    bgColor = 'red-300';
    fontColor = 'N0';
    icon = <DueDateIconComplete />;
  } else if (!isComplete && isDueNow) {
    bgColor = 'red-500';
    fontColor = 'N0';
    icon = <DueDateIconComplete />;
  } else if (!isComplete && isDueSoon) {
    bgColor = 'yellow-500';
    fontColor = 'N0';
    icon = <DueDateIconComplete />;
  } else if (isComplete) {
    bgColor = 'green-500';
    fontColor = 'N0';
    icon = <DueDateIconComplete />;
  }

  return (
    <IconBadge bgColor={bgColor} fontColor={fontColor} icon={icon}>
      {children}
    </IconBadge>
  );
};

export default DueDateBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/DueDateBadge.js